import { React, useState, Image } from "react";
import Header from "../../Components/Header";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCard from "../../Components/SkillCard";
import MobileDropdown from "../../Components/MobileDropdown";
import MobileFooter from "../../Components/MobileFooter";
import { useLocation } from "react-router-dom";
import Game from "./Game.js";
import { Link } from "react-router-dom";

export default function Friends() {
  let ballerzToken = BallerzToken();

  const location = useLocation();
  const bookingReference = location.state?.bookingReference;

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const { status, data } = useGetRequest("skillzone/friends/leaderboard", {});

  console.log("data", data);

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header
          title={"skillzone"}
          users={data?.users}
          bookingReference={data?.bookingReference}
          username={data?.username}
        />

        <div className="flex flex-1">
          <SideBar usernames={data?.username} />

          <main className="flex-1 p-4 sm:p-6">
            <div className="block mb-4 sm:hidden">
              <MobileDropdown />
            </div>

            <Link
              to="/friends/manage"
              // state={{ username: mainUser }}
              className="w-full flex justify-end cursor-pointer mb-4"
            >
              <button
                className={`w-[220px] text-center text-white text-lg font-semibold py-3 tracking-wide Kallisto_Bold hover:bg-[#3a45c8] ${
                  location.pathname === "/friends" ? "bg-[#4F55F6]" : ""
                }`}
              >
                Manage Friends
              </button>
            </Link>

            <div className="flex flex-col gap-4">
              {data.output.length === 0 && (
                <div className="relative rounded-2xl overflow-hidden">
                  <div className="pointer-events-none absolute -inset-0.5 bg-gradient-to-r from-[#3a45c8]/40 via-[#6b6fff]/20 to-transparent blur-lg opacity-60"></div>

                  <div className="relative bg-[#10164a]/80 backdrop-blur-md rounded-2xl p-8 border border-white/10 shadow-[0_20px_40px_rgba(0,0,0,0.35)]">
                    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 border border-white/20 shadow">
                      <span className="text-2xl">🏆</span>
                    </div>

                    <h2 className="text-2xl Kallisto_Bold text-white tracking-wide text-center">
                      No Top Scores Yet
                    </h2>

                    <div className="mx-auto my-4 h-px w-24 bg-gradient-to-r from-transparent via-white/20 to-transparent" />

                    <p className="text-gray-300 text-sm max-w-sm Kallisto_Bold text-center mx-auto">
                      Once your friends start playing skillzone games, their best scores will
                      appear here.
                    </p>
                  </div>
                </div>
              )}

              {data?.output?.map((data, index) => (
                <Game data={data} />
              ))}
            </div>

            <div className="block sm:hidden">
              <MobileFooter />
            </div>
          </main>
        </div>
      </div>
    );
  }
}
